import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-block-container',
  templateUrl: './block-container.component.html',
  styleUrls: ['./block-container.component.scss']
})
export class BlockContainerComponent {
  @Input() title: string;
}
